<template>
  <v-flex xs12 class="layout-custom" :class="{catalogo}">
    <h2 class="tag-title text-xs-center" :class="{catalogo}">{{title}}</h2>
  </v-flex>
</template>
<script>
  export default {
    props: {
      title: String,
      catalogo: Boolean
    }
  }
</script>


<style scoped>
  .tag-title{
    font-family: Montserrat;
    font-size: calc(1.6em + 1vw);
    color: black;
    line-height: 0.9em;
    text-indent: 10px;
    padding-bottom: 10px;
  }
    .layout-custom {
      /*background: url(../assets/mancha_negra_2.png);*/
      background-size: 100% 300%;
      background-position-y: 53%;
    }
  @media only screen and (max-width: 600px) {
    .layout-custom {
      background-size: 100% 150%;
      background-position-y: 53%;
      height: 150px;
    }
  }
  @media only screen and (max-width: 900px) {
    .layout-custom {
      background-size: 100% 187%;
      background-position-y: 53%;
      height: 151px;
    }
  }
  @media only screen and (min-width: 800px) {
    .layout-custom {
      background-size: 100% 200%;
      background-position-y: 68%;
      height: 200px;
    }
    .tag-title {
      line-height: 0;
    }
  }
  .catalogo {
    background: none !important;
    color: #da2d41 !important;
    height: 120px;
  }
  .catalogo.tag-title {
    color: #da2d41 !important;
    line-height: 1.5em !important;
    padding-top: 1.8em !important;
  }
  .catalogo.layout-custom:before {
    content: ' ';
    background: url(/mancha_negra_1.png);
    background-size: 100%;
    background-repeat: no-repeat;
    position: absolute;
    width: 100%;
    height: 100%;
    top: -19vw;
    -webkit-transition: background 2s;
    transition: background 2s;
    pointer-events: none;
  }
</style>
